import { NavItem } from '../interfaces/navItem';
import { CollectionPointZone } from '../interfaces/collectionPointZone';
import { CollectionPointType } from '../interfaces/collectionPointType';
import { Role } from '../interfaces/role';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Catalog } from '../interfaces/catalog';
import { CatalogItem } from '../interfaces/catalogItem';
import { Permission } from './permission';
import { ExcelField } from '../interfaces/fieldsColumnCargo';
import { VehicleDocumentCatalog } from '../interfaces/vehicleDocuments';
import { ProtectionElements } from '../interfaces/protectionElementInspectVehicle';
import { Injectable } from "@angular/core";

@Injectable()
export class Global {

  currentYear = new Date().getFullYear();
  permission = Permission;
  _k: string = "T3CL0g12020";
  pathImgLogoteclogi: string = "./assets/img/logo.png";
  pathImgLogoLoggiapp: string = "./assets/loggiapp-icons/128_transp.png";
  pathMarkerOrigin: string = "/assets/img/pin-origin.png";
  pathImgTransparent: string = "/assets/img/transparent.png";
  pathMarkerDestination: string = "/assets/img/pin-destination.png";
  pathMarkerVehicle: string = "/assets/img/pin-vehicle-inverted.png";
  pathMarkerSatelliteLock: string = "/assets/img/icono-candado.png";
  pathMarkerVehicleNoLastLocations: string = "/assets/img/banderita.png";
  pathMarkerLocation: string = "/assets/img/location.png";
  pathMarkerCriticZone: string = "/assets/svg/icons/tl_ico__pin_google_maps_trip_alert.svg";
  pathClusterMarker: string = "/assets/img/clusters-";
  pathLocationPin: string = "/assets/img/location-pin.png";
  markerTrackingFreightForwarder: string = 'trackingFreightForwarder';
  markerPointRoute: string = 'markerPointRoute';
  markerGeneral: string = 'markerGeneral';
  pathNoImage: string = "/assets/svg/icons/icon-no-file.svg";

  defaultRoles = {
    webUserPendingActivate: {
      id: 'webUserPendingActivate',
      nit: '',
      name: 'webUserPendingActivate'
    },
    Driver: {
      id: 'Driver',
      nit: '',
      name: 'Driver'
    }
  };

  guideState: string = "GuideState";

  typeFilesExport = {
    xls: {
      format: 'xlsx',
      name: 'XLSX',
      contentType: 'application/octet-stream'
    },
    csv: {
      format: 'csv',
      name: 'csv',
      contentType: 'application/csv'
    },
    txt: {
      format: 'txt',
      name: 'txt',
      contentType: 'application/txt'
    },
    pdf: {
      format: 'pdf',
      name: 'pdf',
      contentType: 'application/pdf'
    }
  };

  typesExportList = {
    collectionPoint: 1,
    freightForwarder: 2,
    reports: 3
  };

  companiesEnabledsToExport = [
    "8305072789" // gl
  ]

  //type fiels
  typeFiles: Array<Object> = [
    {
      idFile: 1,
      title: 'RUT',
      file: null,
      name: '',
      uploaded: false,
      size: 0,
      storageRef: null,
      uploadTask: null,
      uploadProgress: null
    },
    {
      idFile: 2,
      title: 'Estados financieros',
      file: null,
      name: '',
      uploaded: false,
      size: 0,
      storageRef: null,
      uploadTask: null,
      uploadProgress: null
    },
    {
      idFile: 3,
      title: 'Circular 018',
      file: null,
      name: '',
      uploaded: false,
      size: 0,
      storageRef: null,
      uploadTask: null,
      uploadProgress: null
    },
    {
      idFile: 4,
      title: 'Certificado Basc, OEA o Acuerdo de seguridad',
      file: null,
      name: '',
      uploaded: false,
      size: 0,
      storageRef: null,
      uploadTask: null,
      uploadProgress: null
    },
    {
      idFile: 5,
      title: 'Certificación de calidad y otros',
      file: null,
      name: '',
      uploaded: false,
      size: 0,
      storageRef: null,
      uploadTask: null,
      uploadProgress: null
    },
    {
      idFile: 6,
      title: 'Referencia bancaria',
      file: null,
      name: '',
      uploaded: false,
      size: 0,
      storageRef: null,
      uploadTask: null,
      uploadProgress: null
    },
    {
      idFile: 7,
      title: 'Referencia comercial',
      file: null,
      name: '',
      uploaded: false,
      size: 0,
      storageRef: null,
      uploadTask: null,
      uploadProgress: null
    }
  ];

  // Menu options
  public menu: NavItem[] = [
    {
      displayName: 'Documentos Legales',
      name: 'legalDocuments',
      iconName: 'file-alt',
      expanded: false,
      visible: false,
      responsive: false,
      childrens: [
        {
          displayName: 'Catálogos',
          name: 'adminLegalDocuments',
          route: '/legal-documents/list',
          visible: true
        }
      ]
    },
    {
      displayName: 'Administración',
      name: 'administration',
      iconName: 'users-cog',
      expanded: false,
      visible: false,
      responsive: false,
      childrens: [
        {
          displayName: 'Crear Usuario',
          route: '/administration/admin-users/create',
          visible: false
        },
        {
          displayName: 'Usuarios',
          name: 'adminUsers',
          route: '/administration/admin-users/list',
          visible: false
        },
        {
          displayName: 'Ciudades',
          name: 'adminCities',
          route: '/administration/cities/list',
          visible: false
        },
        {
          displayName: 'Vehículos',
          name: 'adminVehicles',
          route: '/administration/vehicles/list',
          visible: false
        },
        {
          displayName: 'Candados Satelitales',
          name: 'adminSatelliteLock',
          route: '/administration/satellite-lock/list',
          visible: false
        },
        {
          displayName: 'Trailers',
          name: 'adminTrailers',
          route: '/administration/trailers/list',
          visible: false
        },
        {
          displayName: 'Empresas',
          name: 'adminCompanies',
          route: '/administration/companies/list',
          visible: false
        },
        {
          displayName: 'Terceros',
          name: 'adminThirdParty',
          route: '/administration/third-party/list',
          visible: false
        },
        {
          displayName: 'Roles',
          name: 'adminRoles',
          route: '/administration/roles/list',
          visible: false
        },
        {
          displayName: 'Modulos',
          name: 'adminModules',
          route: '/administration/module/list',
          visible: false
        },
        {
          displayName: 'Configuración SaaS',
          name: 'updateCompany',
          route: '/administration/companies/config',
          visible: false
        },
        {
          displayName: 'Mantenimientos',
          name: 'adminMaintenance',
          route: '/administration/maintenance/list',
          visible: false
        }
      ]
    },
    {
      displayName: 'Financiero',
      iconName: 'money-bill-wave',
      name: 'payments',
      expanded: false,
      visible: false,
      responsive: false,
      childrens: [
        {
          displayName: 'Aprobar Servicios',
          route: '/cargo/list/approvePayments',
          name: 'approvePayments',
          visible: false
        },
        {
          displayName: 'Cumplidos RNDC',
          route: '/cargo/list/rndcFulfillments',
          name: 'rndcFulfillments',
          visible: false
        },
        {
          displayName: 'Realizar Pagos',
          route: '/cargo/list/paymentCargo',
          name: 'paymentCargo',
          visible: false
        },
        {
          displayName: 'Consultar viáticos',
          route: '/cargo/list/travelExpensesChecking',
          name: 'travelExpensesChecking',
          visible: false
        },
        {
          displayName: 'Prefacturación',
          route: '/cargo/pre-bill',
          name: 'preBill',
          visible: false
        },
        {
          displayName: 'Facturacion',
          route: '/cargo/list/charges',
          name: 'charges',
          visible: false
        },
        {
          displayName: 'Cartera',
          name: 'adminReceivable',
          route: '/administration/receivable/list',
          visible: false
        },
        {
          displayName: 'Generación de Archívos',
          name: 'generateAccountingFiles',
          route: '/cargo/expenses-income',
          visible: false
        }
      ]
    },
    {
      displayName: 'Servicio',
      name: 'cargo',
      iconName: 'truck-loading',
      expanded: false,
      visible: false,
      responsive: false,
      childrens: [
        {
          displayName: 'Reportes',
          route: '/reports/main',
          name: 'reports',
          visible: false,
          responsive: false
        },
        {
          displayName: 'Crear servicios',
          name: [
            'createManualCargo',
            'createCargoRequest',
            'createCargoByGuides',
            'createMassiveCargo',
            'createCargoFromRoute',
            'createEscortService',
            'createSatelliteLockService',
          ],
          route: '/cargo/create',
          visible: false
        },
        {
          displayName: 'Solicitudes',
          name: 'cargoRequest',
          route: '/cargo/list/request',
          visible: false
        },
        {
          displayName: 'Panel de asignaciones',
          route: '/cargo/panelAssignments',
          name: 'panelAssignments',
          visible: false,
        },
        {
          displayName: 'Servicios programados',
          route: '/cargo/list/scheduledLoads',
          name: 'scheduledCargo',
          visible: false
        },
        {
          displayName: 'Enturnamiento',
          name: 'turn',
          route: '/cargo/list/enturnamiento',
          visible: false
        },
        {
          displayName: 'Servicios en ruta',
          name: 'cargosInRoute',
          route: '/cargo/list/loadingRoutes',
          visible: false
        },
        {
          displayName: 'Tracking Global',
          route: '/cargo/global-tracking',
          name: 'cargosInRoute',
          visible: false,
        },
        {
          displayName: 'Servicios terminados',
          route: '/cargo/list/loadsFinished',
          name: 'finishedCargos',
          visible: false
        },
        {
          displayName: 'Validación de servicios',
          name: 'prevalidationCargos',
          route: '/cargo/prevalidation',
          visible: false
        },
        {
          displayName: 'Retransmisión RNDC',
          name: 'viewRndc',
          route: '/rndc',
          visible: false
        },
        {
          displayName: 'Servicios vencidos',
          route: '/cargo/list/expired',
          name: 'expiredCargo',
          visible: false
        },
        {
          displayName: 'Servicios eliminados',
          route: '/cargo/list/deleted',
          name: 'deletedCargo',
          visible: false
        },
      ]
    },
    {
      displayName: 'Ruteo',
      iconName: 'fas fa-map-marked-alt',
      name: 'routing',
      expanded: false,
      visible: false,
      responsive: false,
      childrens: [
        {
          displayName: 'Crear Ruteo',
          name: 'createRouting',
          route: '/routing/create-route',
          visible: false
        },
        {
          displayName: 'Listado de ruteos',
          name: 'routingList',
          route: '/routing/route-list',
          visible: false
        },
      ]
    },
    {
      displayName: 'Guías',
      name: 'guide',
      iconName: 'file',
      expanded: false,
      visible: false,
      responsive: false,
      childrens: [
        {
          displayName: 'Cargar guías',
          name: [/*this.permission.guide.loadGuides, this.permission.guide.changeStateGuides, this.permission.guide.loadGuides*/],
          route: '/guide/upload-guides',
          visible: false
        },
        {
          displayName: 'Listado de guías',
          name: 'guideList',
          route: '/guide/guideList',
          visible: false
        },
        {
          displayName: 'Rastreo de Guias',
          name: 'trackGuide',
          route: '/guide/track-guide',
          visible: true
        }
      ]
    },
    {
      displayName: 'Puntos',
      name: 'point',
      iconName: 'map-marker-alt',
      expanded: false,
      visible: false,
      responsive: false,
      childrens: [
        {
          displayName: 'Crear punto',
          name: 'createPoint',
          route: '/collection-point/create',
          visible: false
        },
        {
          displayName: 'Listado de puntos',
          name: 'listPoints',
          route: '/collection-point/list',
          visible: false
        }
      ]
    },
    {
      displayName: 'Calendario',
      iconName: 'calendar-alt',
      name: 'calendar',
      expanded: false,
      visible: false,
      childrens: [
        {
          displayName: 'CEDI',
          name: 'schedule-cedi',
          route: '/schedule/booking',
          visible: false
        },
      ]
    },
    {
      displayName: 'Rutas',
      name: 'routes',
      iconName: 'route',
      expanded: false,
      visible: false,
      responsive: false,
      childrens: [
        // {
        //   displayName: 'Novedades',
        //   name: [this.permission.guide.loadGuides, this.permission.guide.changeStateGuides, this.permission.guide.loadGuides],
        //   route: '/routes/news',
        //   visible: true
        // },
        {
          displayName: 'Rutas',
          name: this.permission.routes.routePlanning,
          route: '/routes/planning',
          visible: false
        },
        {
          displayName: 'Sitios Autorizados',
          name: this.permission.routes.routeSites,
          route: '/routes/sites',
          visible: false
        },
        {
          displayName: 'Zonas críticas',
          name: this.permission.routes.routeCriticZones,
          route: '/routes/critic-zones',
          visible: false
        },
        // {
        //   displayName: 'Condiciones inseguras',
        //   name: 'unsafeConditions',
        //   route: '/routes/unsafe-conditions',
        //   visible: true
        // }
      ]
    },
    {
      displayName: 'Configuración',
      iconName: 'cog',
      name: 'setting',
      expanded: false,
      visible: false,
      responsive: false,
      childrens: [
        // {
        //     displayName: 'Documentos de la empresa',
        //     name: 'companyDocuments',
        //     route: '/settings/documents',
        //     visible: false
        // },
        {
          displayName: 'Cambiar contraseña',
          route: '/settings/password',
          name: 'changePassword',
          visible: false
        },
        {
          displayName: 'Términos y condiciones',
          route: '/terms',
          name: 'termsAndConditions',
          visible: false
        },
        {
          displayName: 'Politicas de privacidad',
          route: '/privacy-policy',
          name: 'privacyPolicy',
          visible: false
        },
        {
          displayName: 'Politicas tratamiento de datos personales',
          route: '/personal-data-policies',
          name: 'personalDataPolicies',
          visible: false
        },
        {
          displayName: 'HABEAS DATA',
          route: '/habeas-data',
          name: 'habeasData',
          visible: false
        },
        {
          displayName: 'Anexo Manifiesto de Carga',
          route: '/terms-manifest',
          name: 'termsManifest',
          visible: false
        },
        {
          displayName: 'Politicas BASC',
          route: '/basc-policies',
          name: 'bascPolicies',
          visible: false
        },
        {
          displayName: 'Pronto Pago',
          route: '/quick-pay',
          name: 'quickPay',
          visible: false
        }
      ]
    },
    /*{
      displayName: 'Soporte',
      iconName: 'ticket-alt',
      name: 'help-desk',
      expanded: false,
      visible: false,
      responsive: false,
      childrens: [
        {
          displayName: 'Tickets',
          name: 'listTicket',
          route: '/help-desk/list',
          visible: false
        },
      ]
    },*/
    {
      displayName: 'Monitoring',
      iconName: 'desktop',
      name: 'monitoring',
      expanded: false,
      visible: false,
      responsive: false,
      childrens: [
        {
          displayName: 'Logging',
          name: 'monitorlogging',
          route: '/monitoring/logging',
          visible: false
        },
        {
          displayName: 'Solicitudes por usuario',
          name: 'fingerprintslogging',
          route: '/monitoring/fingerprintslogging',
          visible: false
        },
      ]
    },
    {
      displayName: 'Analítica de datos',
      iconName: 'chart-bar',
      name: 'analytics',
      expanded: false,
      visible: false,
      responsive: false,
      childrens: [
        {
          displayName: 'Operaciones',
          name: 'analyticsOperations',
          route: '/analytics/analyticsOperations',
          visible: false
        },
        {
          displayName: 'Vehículos',
          name: 'vehicleAnalytics',
          route: '/analytics/vehicleAnalytics',
          visible: false
        },
        {
          displayName: 'Rutas frecuentes',
          name: 'frequentRoutes',
          route: '/analytics/frequentRoutes',
          visible: false
        },
        {
          displayName: 'Despachos',
          name: 'dispatch',
          route: '/analytics/dispatch',
          visible: false
        },
        {
          displayName: 'Servicios detenidos',
          name: 'stopedCargos',
          route: '/analytics/stopedCargos',
          visible: false
        },
        {
          displayName: 'Métricas históricas',
          name: 'historicalKPI',
          route: '/analytics/historicalKPI',
          visible: false
        },
        {
          displayName: 'Pagos',
          name: 'paymentsDashboard',
          route: '/analytics/paymentsDashboard',
          visible: false
        },
        {
          displayName: 'Facturación',
          name: 'analyticsBilling',
          route: '/analytics/analyticsBilling',
          visible: false
        },
        {
          displayName: 'Operación ITR',
          name: 'operationITR',
          route: '/analytics/operationITR',
          visible: false
        },
        {
          displayName: "Operaciones Enturnamiento",
          name: "operationsTurn",
          route: '/analytics/operationsTurn',
          visible: false,
        },
        {
          displayName: "Comercial Enturnamiento",
          name: "comercialTurn",
          route: "/analytics/comercialTurn",
          visible: false
        },
        {
          displayName: "Optimización de costos SICE TAC",
          name: "sicetac",
          route: "/analytics/sicetac",
          visible: false
        },
        {
          displayName: "Mis vehículos",
          name: "vehiclesOwnFleet",
          route: "/analytics/vehiclesOwnFleet",
          visible: false
        },
        {
          displayName: "Histórico de documentos",
          name: "historicalDocuments",
          route: "/analytics/historicalDocuments",
          visible: false
        },
        {
          displayName: "Análisis de rentabilidad",
          name: "profitabilityAnalysis",
          route: "/analytics/profitabilityAnalysis",
          visible: false
        },
        {
          displayName: "Venta perdida",
          name: "lostSales",
          route: "/analytics/lostSales",
          visible: false,
        },
        {
          displayName: "Reporte UIAF",
          name: "reportUIAF",
          route: "/analytics/reportUIAF",
          visible: false
        },
        {
          displayName: "Cumplidos",
          name: "fulfillments",
          route: "/analytics/fulfillments",
          visible: false
        },
        {
          displayName: "Cumplidos clientes",
          name: "fulfillmentsClients",
          route: "/analytics/fulfillmentsClients",
          visible: false
        },
      ]
    },
  ];
  collectionPointZones: CollectionPointZone[] = [
    {
      name: "Tuta"
    },
    {
      name: "Cogua"
    }
    ,
    {
      name: "Simijaca"
    }
  ];

  collectionPointTypes: CollectionPointType[] = [
    {
      name: "CALIENTE"
    },
    {
      name: "FRIA"
    }
  ];

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '150px',
    minHeight: '100px',
    maxHeight: '500px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Ingrese el texto aquí...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['bold', 'italic'],
      ['fontSize']
    ]
  };

  public listTypeDocuments: VehicleDocumentCatalog[] =
    [
      { name: 'frontPicture' },
      { name: 'leftLateralPicture' },
      { name: 'rightLateralPicture' },
      { name: 'propertyCard' }
    ];

  public typesReports = [
    {
      id: 'addressDuration',
      name: 'Duracion en cada dirección'
    },
    {
      id: 'addressQuantity',
      name: 'Cantidad de unidades en cada dirección'
    },
    {
      id: 'routeDuration',
      name: 'Duracion total de cada servicio'
    },
    {
      id: 'dayQuantity',
      name: 'Cantidad de unidades por días'
    },
    {
      id: 'durationTakeCargo',
      name: 'Duración en tomar el servicio'
    }
  ];

  // Catálogo completo de perfiles de riesgo. Los perfiles que se pueden ofrecer al usuario dependen
  // de la configuración del tenant: usar RiskProfileService.availableProfiles, no esta lista directa.
  public riskProfiles: CatalogItem[] = [
    { id: '1', name: 'Riesgo bajo' },
    { id: '2', name: 'Riesgo medio' },
    { id: '3', name: 'Riesgo alto' }
  ];

  public documenTypes: CatalogItem[] = [
    {
      id: '1',
      name: 'Cédula de ciudadanía'
    },
    {
      id: '2',
      name: 'Pasaporte'
    },
    {
      id: '3',
      name: 'NIT'
    },
    {
      id: '4',
      name: 'Tarjeta de identidad'
    },
    {
      id: '5',
      name: 'Cédula de extranjería'
    }
  ];

  public fieldsGuide = [
    {
      id: 'guideId',
      title: 'Id. de Guía (*)',
      disabled: false
    },
    {
      id: 'origin',
      title: 'Origen (*)',
      disabled: false
    },
    {
      id: 'clientName',
      title: 'Cliente nombre (*)',
      disabled: false
    },
    {
      id: 'destination',
      title: 'Ciudad Destino (*)',
      disabled: false
    },
    {
      id: 'destinationAddress',
      title: 'Dirección de destino (*)',
      disabled: false
    },
    {
      id: 'product',
      title: 'Producto (*)',
      disabled: false
    },
    {
      id: 'clientId',
      title: 'Id. de Cliente',
      disabled: false
    },
    {
      id: 'clientEmail',
      title: 'Cliente email',
      disabled: false
    },
    {
      id: 'clientCellPhone',
      title: 'Cliente celular',
      disabled: false
    },
    {
      id: 'addressComplement',
      title: 'Complemento dirección',
      disabled: false
    },
    {
      id: 'neighborhood',
      title: 'Barrio',
      disabled: false
    },
    {
      id: 'lat',
      title: 'Latitud',
      disabled: false
    },
    {
      id: 'lng',
      title: 'Longitud',
      disabled: false
    },
    {
      id: 'zone',
      title: 'Zona',
      disabled: false
    },
    {
      id: 'deadLine',
      title: 'Fecha máxima para entregar',
      disabled: false
    },
    {
      id: 'productId',
      title: 'Id. de producto',
      disabled: false
    },
    {
      id: 'cost',
      title: 'Costo',
      disabled: false
    },
    {
      id: 'store',
      title: 'Tienda',
      disabled: false
    },
    {
      id: 'packagesNumber',
      title: 'Número de paquétes',
      disabled: false
    },
  ];

  public fieldsXLSXCargo: ExcelField[] = [
    {
      id: 'numberDocumentSender',
      title: 'Código identificador de cliente*',
      disabled: false,
      mandatory: true
    },
    {
      id: 'tripName',
      title: 'Tipo de viaje*',
      disabled: false,
      mandatory: true
    },
    {
      id: 'vehicleTypeName',
      title: 'Tipo de vehículo*',
      disabled: false,
      mandatory: true
    },
    {
      id: 'bodyWorkTypeName',
      title: 'Tipo de carrocería*',
      disabled: false,
      mandatory: true
    },
    {
      id: 'shippingCostTotal',
      title: 'Flete*',
      disabled: false,
      mandatory: true
    },
    {
      id: 'dateCargo',
      title: 'Fecha de cargue*',
      disabled: false,
      mandatory: true
    },
    {
      id: 'nit',
      title: 'NIT',
      disabled: false,
      mandatory: false
    },
    {
      id: 'cargoTypeName',
      title: 'Tipo de carga',
      disabled: false,
      mandatory: false
    },
    {
      id: 'serviceTypeName',
      title: 'Tipo de servicio',
      disabled: false,
      mandatory: false
    },
    {
      id: 'productDescription',
      title: 'Descripción del producto',
      disabled: false,
      mandatory: false
    },
    {
      id: 'cargoMeasureQuantity',
      title: 'Cantidad de paquetes',
      disabled: false,
      mandatory: false
    },
    {
      id: 'cargoMeasureTotal',
      title: 'Medida total',
      disabled: false,
      mandatory: false
    },
    {
      id: 'cargoMeasureTotalWeigth',
      title: 'Peso total',
      disabled: false,
      mandatory: false
    },
    {
      id: 'cargoMeasureTotalAmount',
      title: 'Valor total',
      disabled: false,
      mandatory: false
    },
    {
      id: 'cargoMeasureTotalType',
      title: 'Tipo de paquete',
      disabled: false,
      mandatory: false
    },
    {
      id: 'licensePlate',
      title: 'Placa',
      disabled: false,
      mandatory: false
    },
    {
      id: 'rate',
      title: 'Tarifa',
      disabled: false,
      mandatory: false
    },
    {
      id: 'advancePercentage',
      title: '% de anticipo',
      disabled: false,
      mandatory: false
    },
    {
      id: 'observations',
      title: 'Observaciones',
      disabled: false,
      mandatory: false
    },

  ];
  public errorsFieldsExcelDict = {
    cargoTypeName: {
      alias: 'Tipo de carga',
      field: 'cargoModel.cargoType.name'
    },
    serviceTypeName: {
      alias: 'Tipo de servicio',
      field: 'cargoModel.serviceType.name'
    },
    cargoMeasureQuantity: {
      alias: 'Cantidad de paquetes',
      field: 'cargoFeature.cargoMeasure.quantity'
    },
    cargoMeasureTotal: {
      alias: 'Medida total',
      field: 'cargoFeature.cargoMeasure.totalMeasurement'
    },
    cargoMeasureTotalWeigth: {
      alias: 'Peso total',
      field: 'cargoFeature.cargoMeasure.totalWeigth'
    },
    cargoMeasureTotalAmount: {
      alias: 'Valor declarado de la mercancia',
      field: 'cargoFeature.cargoMeasure.amount'
    },
    cargoMeasureTotalType: {
      alias: 'Unidad',
      field: 'cargoFeature.cargoMeasure.unit'
    },
    advancePercentage: {
      alias: 'Porcentaje de anticipo',
      field: 'shippingCost.advancePercentage'
    },
    rate: {
      alias: 'Tarífa',
      field: 'shippingCost.rate'
    },
    licensePlate: {
      alias: 'Placa',
      field: 'licensePlate'
    },
  }

  public statusGuide = {
    "Created": "Creado",
    "To pick up": "Por recoger",
    "On way": "En camino",
    "In warehouse": "En almacén",
    "To distribute": "Por distribuir",
    "In distribution": "En distribución",
    "Delivered": "Entregado",
    "Waiting to start route": "Esperando Inicio de Ruta",
    "Loading in progress": "Carga en proceso",
    "Starting service": "Iniciando servicio",
    "In transit": "En tránsito",
    "Arrived at destination": "Llegada a destino",
    "Confirmation Pending": "Por confirmar",
    "Service confirmed": "Servicio confirmado",
    "Return to warehouse": "Regreso a bodega"
  }

  public vehicleEditableFieldsAlias = {
    'manufacturingYear': 'Año modelo',
    'brand.description': 'Marca',
    'color': 'Color',
    'axles': 'N° de ejes',
    'line.description': 'Línea',
    'fuelType.description': 'Tipo de combustible',
    'chassisId': 'N° de Chasis',
    'motorId': 'N° de motor',
    'emptyWeight': 'Peso vacío',
    'grossWeight': 'Peso bruto',
    'capacity': 'Capacidad de carga',
  };
  public vehicleEditableFields = Object.keys(this.vehicleEditableFieldsAlias);

  public dialogSurveySections = {
    "condiciones del usuario": "Condiciones del usuario",
    "verificacion del sistema electrico": "Verificacion del sistema eléctrico",
    "estado mecanico": "Estado mecánico",
    "estado de funcionamiento del motor": "Estado del funcionamiento del motor",
    "estructura del vehiculo": "Estructura del vehículo",
    "carroceria": "Carrocería",
    "elementos de proteccion personal": "Elementos de protección personal",
    "inspeccion del vehiculo": "Inspección del vehículo",
    "inspeccion a la unidad de carga": "Inspección a la unidad de carga",
    "inspeccion de cisterna": "Inspección de cisterna",
  }

  public authorizedPoints: { name: string, value: string, icon: string, index?: number }[] = [
    { name: 'Hotel', value: 'point1', icon: 'tl_ico__pin_google_maps_trip_hotel.svg', index: 1 },
    { name: 'Gasolinera', value: 'point2', icon: 'tl_ico__pin_google_maps_trip_gas.svg', index: 2 },
    { name: 'Parqueadero', value: 'point3', icon: 'tl_ico__pin_google_maps_trip_parking.svg', index: 3 },
    { name: 'Restaurante', value: 'point4', icon: 'tl_ico__pin_google_maps_trip_restaurant.svg', index: 4 }
  ];

  consignmentFieldsToCheck: { field: string, alias: string }[] = [
    { field: 'operationType.code', alias: 'tipo de remesa' },
    { field: 'operationType.description', alias: 'tipo de remesa' },
    { field: 'cargoNature.code', alias: 'naturaleza de la carga' },
    { field: 'cargoNature.description', alias: 'naturaleza de la carga' },
    { field: 'packagingType.code', alias: 'tipo de empaque' },
    { field: 'packagingType.description', alias: 'tipo de empaque' },
    { field: 'merchandise.code', alias: 'mercancia (Partida)' },
    { field: 'merchandise.description', alias: 'mercancia (Partida)' },
    { field: 'cargoOwner.documentType', alias: 'propietario de la carga' },
    { field: 'cargoOwner.documentNumber', alias: 'propietario de la carga' },
    { field: 'cargoOwner.name', alias: 'propietario de la carga' },
    { field: 'cargoOwner.branchOffice', alias: 'dirección del propietario de la carga' },
    { field: 'totalWeight', alias: 'peso' },
    { field: 'weightUnit', alias: 'unidad de medida' },
    { field: 'sender.city', alias: 'ciudad del remitente' },
    { field: 'sender.cityId', alias: 'ciudad del remitente' },
    { field: 'sender.municipalityCode', alias: 'ciudad del remitente' },
    { field: 'sender.documentType', alias: 'remitente' },
    { field: 'sender.documentNumber', alias: 'remitente' },
    { field: 'sender.name', alias: 'remitente' },
    { field: 'sender.branchOffice', alias: 'dirección del remitente' },
    { field: 'sender.address', alias: 'dirección del remitente' },
    { field: 'sender.addressId', alias: 'dirección del remitente' },
    { field: 'sender.location', alias: 'dirección del remitente' },
    { field: 'sender.location.lat', alias: 'dirección del remitente' },
    { field: 'sender.location.lng', alias: 'dirección del remitente' },
    { field: 'load.hours', alias: 'tiempo pactado de cargue' },
    { field: 'load.minutes', alias: 'tiempo pactado de cargue' },
    { field: 'recipient.city', alias: 'ciudad del destinatario' },
    { field: 'recipient.cityId', alias: 'ciudad del destinatario' },
    { field: 'recipient.municipalityCode', alias: 'ciudad del destinatario' },
    { field: 'recipient.documentType', alias: 'destinatario' },
    { field: 'recipient.documentNumber', alias: 'destinatario' },
    { field: 'recipient.name', alias: 'destinatario' },
    { field: 'recipient.branchOffice', alias: 'dirección del destinatario' },
    { field: 'recipient.address', alias: 'dirección del destinatario' },
    { field: 'recipient.addressId', alias: 'dirección del destinatario' },
    { field: 'recipient.location', alias: 'dirección del destinatario' },
    { field: 'recipient.location.lat', alias: 'dirección del destinatario' },
    { field: 'recipient.location.lng', alias: 'dirección del destinatario' },
    { field: 'unload.hours', alias: 'tiempo pactado de descargue' },
    { field: 'unload.minutes', alias: 'tiempo pactado de descargue' },
  ];

  productTypeStates = [
    { code: 'L', description: 'LIQUIDO', label: 'Liquido' },
    { code: 'S', description: 'SOLIDO', label: 'Sólido o semisólido' },
    { code: 'G', description: 'GASEOSO', label: 'Gaseoso' },
  ];
  packagingOptions = [
    { code: 'I', description: 'Sustancias muy peligrosas' },
    { code: 'II', description: 'Sustancias medianamente peligrosas' },
    { code: 'III', description: 'Sustancias poco peligrosas' }
  ];
  dangerousCharacteristics = [
    { code: 'COR', description: 'Corrosivo' },
    { code: 'REA', description: 'Reactivo' },
    { code: 'EXP', description: 'Explosivo' },
    { code: 'TOX', description: 'Toxico' },
    { code: 'IFM', description: 'Inflamable' },
    { code: 'IFC', description: 'Infeccioso' },
    { code: 'RAD', description: 'Radiactivo' }
  ];
}
